import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";

import { API_URL, AUTH0_CLIENT_ID, AUTH0_DOMAIN } from "./constants";

const useAuth = () => {
  const {
    logout,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0();

  return {
    logout,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    getAccessToken: getAccessTokenSilently,
  };
};

const AuthProvider = ({ children }: { children: JSX.Element }) => {
  return (
    <Auth0Provider
      cacheLocation="localstorage"
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: API_URL,
        redirect_uri: window.location.origin,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export { AuthProvider, useAuth };
